import { MenuOutlined, PushpinFilled } from "@ant-design/icons";
import { Button, Card } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import InterventionMenuTree from "@/modules/intervention/intervention-menu-tree";

import { useInterventionMenuCard } from "./intervention-menu-card.hook";

import "./intervention-menu-card.style.less";

const InterventionMenuCard = () => {
  const { t } = useTranslation();
  const {
    isLoading,
    isVisible,
    isHoverMode,
    onButtonClick,
    onButtonMouseOver,
    onCardMouseLeave,
  } = useInterventionMenuCard();

  return (
    <div
      className={classNames("intervention-menu-card-wrapper", {
        "-visible": isVisible,
        "-hover-mode": isHoverMode,
      })}
    >
      <Button
        size="large"
        icon={<MenuOutlined />}
        onClick={onButtonClick}
        onMouseOver={onButtonMouseOver}
        className="intervention-menu-show-button"
      />
      <Card
        title={t("intervention:menu.title")}
        loading={isLoading}
        onMouseLeave={onCardMouseLeave}
        className="intervention-menu-card"
        extra={
          <Button
            onClick={onButtonClick}
            icon={<PushpinFilled />}
            shape="circle"
            size="small"
            type="text"
            className="intervention-menu-hide-button"
          />
        }
      >
        <InterventionMenuTree />
      </Card>
    </div>
  );
};

export default InterventionMenuCard;
